import { PropType } from 'vue';

import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';

import { JsonSchemaFormCustomComponentInput } from '@evidentid/dashboard-commons/components/JsonSchemaForm/types';
import JsonForm from '@evidentid/json-schema/interfaces/JsonForm';

@Component
class AbstractJsonSchemaForm<T = JsonForm, V = any> extends Vue {
    @Prop(Object)
    protected form!: T;

    @Prop()
    protected value!: V;

    @Prop({ type: Boolean, default: false })
    protected required!: boolean;

    @Prop(String)
    protected id!: string;

    @Prop({ type: Number, default: 0 })
    protected depth!: number;

    // PRODUCT-26110 Phase 2B2: renamed from PascalCase `FormElementComponent` — Vue 3
    // camelizes the kebab-case attr, so a PascalCase prop never matches (see the
    // dashboard-commons AbstractJsonSchemaForm for the full story).
    // PRODUCT-26110 QA fixes4: the value passed in is a component definition OBJECT,
    // not a plain `Function` -- accept both so Vue 3's prop-type check doesn't warn.
    @Prop({ type: [ Function, Object ] as PropType<Vue.Component> })
    protected formElementComponent!: Vue.Component;

    @Prop({ type: [ Object, Function ] as PropType<JsonSchemaFormCustomComponentInput | null> })
    protected customComponentInput?: JsonSchemaFormCustomComponentInput | null;
}

const AbstractJsonSchemaFormMixin = Mixins(AbstractJsonSchemaForm) as typeof AbstractJsonSchemaForm;
export default AbstractJsonSchemaFormMixin;
